import * as React from 'react';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router';
import { ROUTES } from '../../models/routes';
import { rootStore } from '../../stores';
import { queryString } from '../../services/Utils';
import { embeddingService } from '../../services/embedding/EmbeddingService';
import { SHARE_LINK_DATA_PARAM, SHARE_LINK_VERSION_PARAM } from '../../consts';

interface IProps {
  from: string;
  to: string;
}

class RedirectWithQueryParams extends React.Component<IProps> {
  render() {
    const { from, to } = this.props;
    return (
      <Route
        path={from}
        component={(props: RouteComponentProps) => {
          const url = `${to}${props.location.search}`;
          return <Redirect to={url} />;
        }}
      />
    );
  }
}

export class BackwardCompatibilityRoutes extends React.Component<RouteComponentProps> {
  // todo: embedded mode supports only project share for now
  sharedProjectData = () => {
    const { location } = rootStore;
    const searchParams = queryString(location.search);
    const version = searchParams[SHARE_LINK_VERSION_PARAM] as string | undefined;
    const link = searchParams[SHARE_LINK_DATA_PARAM] as string | undefined;
    if (!version || !link) {
      return undefined;
    }

    return {
      version,
      link
    };
  };

  render() {
    const sharedProjectData = this.sharedProjectData();
    if (sharedProjectData && embeddingService.isEmbedded) {
      return (
        <Redirect
          to={`${ROUTES.sharedProject}?${SHARE_LINK_VERSION_PARAM}=${sharedProjectData.version}&${SHARE_LINK_DATA_PARAM}=${sharedProjectData.link}`}
        />
      );
    }

    return (
      <Switch>
        <RedirectWithQueryParams from="/sharedDoor/" to={ROUTES.sharedDoor} />
        <RedirectWithQueryParams from="/sharedProject/" to={ROUTES.sharedProject} />
        <Redirect to={ROUTES.doorLine} />
      </Switch>
    );
  }
}
